import {Link} from "react-router-dom";
import VideoSource from "../VideoSource";
const availableWidths = [320, 480, 720, 1080];

const HomeCard = ({props}) => {
    const {name, btnText, path, url, year} = props;

    return (
        <div className={`aspect-16 home-video-cont fs-40 relative`}
        >
            <VideoSource path={path} name={name} className={`home-video`} width={availableWidths}/>
            <div className="show__more-cont">
                <h1 className="show__more-title white">{btnText} showreel {year}</h1>
                <Link to={url === "" ? "/error" : url}
                      target={url === "projects" || url === "about" ? "" : "_blank"}
                      className={`${url === "" ? "disabled-link" : ""} block fs-20 white show__more-btn`}
                >
                    Watch full video
                </Link>
            </div>
            {/*<VideoSource path={path} name={name} className={`home-video`} text={text} width={availableWidths}/>*/}
            {/*{!title ?*/}
            {/*    <>*/}
            {/*        <VideoSource path={path} name={name} className={`home-video`} width={availableWidths}/>*/}
            {/*        <div className="show__more-cont">*/}
            {/*            <h1 className="show__more-title white">{text} showreel</h1>*/}
            {/*            <Link to={url === "" ? "/error" : url}*/}
            {/*                  target={url === "projects" || url === "about" ? "" : "_blank"}*/}
            {/*                  className={`${url === "" ? "disabled-link" : ""} block fs-20 white show__more-btn`}*/}
            {/*            >*/}
            {/*                Watch full video*/}
            {/*            </Link>*/}
            {/*        </div>*/}
            {/*    </>*/}
            {/*    :*/}
            {/*    <div className="home-video relative">*/}
            {/*        <img src={img} alt="name" className="home-img"/>*/}
            {/*        <div className="home__card-title flex col space-b ">*/}
            {/*            <h3 className="h3 white">*/}
            {/*                {title}*/}
            {/*            </h3>*/}
            {/*            <p className="white regular text-center">*/}
            {/*                {description}*/}
            {/*            </p>*/}
            {/*            <span className="fs-56 white text-end">{end}</span>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*}*/}
        </div>
    )
}
export default HomeCard